import React from 'react';
import { Link, Navigate } from "react-router-dom";
import { Utils } from '../../../Utils';
import Text from '../Text/Text.js';
import Html from '../Html/Html.js';
import Radio from '../Radio/Radio.js';
import Checkbox from '../Checkbox/Checkbox.js';
import Textarea from '../Textarea/Textarea.js';
import Select from '../Select/Select.js';
import File from '../File/File.js';
import i18n from '../../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import SlideInContent from '../../AnimatedElements/SlideInContent.js';

import './Form.css';

class Form extends React.Component {

  name = '';
  parent = null;
  submit_text = '';

  emptyFormErrors = {};
  emptyFormData = {};
  propsForm = false;

  constructor(props) {
    
    super(props);

    this.inputRefs = [];
    this.slideInRef = React.createRef();
    this.customBlockRefs = {}; // Egyedi blokk komponensek ref-jei
    this.name = typeof props.name != 'undefined' ? props.name : '';
    this.parent = typeof props.parent != 'undefined' ? props.parent : null;
    this.submit_text = typeof props.submit_text != 'undefined' ? props.submit_text : 'OK';
    this.on_save = typeof props.on_save === 'function' ? props.on_save : null;
    this.onBlockSave = typeof props.onBlockSave === 'function' ? props.onBlockSave : null;
    this.onBeforeSubmit = typeof props.onBeforeSubmit === 'function' ? props.onBeforeSubmit : null;
    this.form_source = typeof props.form_source != 'undefined' ? props.form_source : 'server'; 
    this.hiddens = typeof props.hiddens != 'undefined' ? props.hiddens : {};
    this.onSuccess = typeof props.onSuccess === 'function' ? props.onSuccess : null;
    this.onLoaded = typeof props.onLoaded === 'function' ? props.onLoaded : null;
    this.query_params = typeof props.query_params != 'undefined' ? props.query_params : {}; // extra GET paraméterek a get_form kérésekhez
    this.others = typeof props.others != 'undefined' ? props.others : {};
    this.summaryMode = typeof props.summaryMode != 'undefined' ? props.summaryMode : false;
    this.summaryExcludedBlocks = typeof props.summaryExcludedBlocks != 'undefined' ? props.summaryExcludedBlocks : [];
    this.summaryExcludedFields = typeof props.summaryExcludedFields != 'undefined' ? props.summaryExcludedFields : [];
    this.customBlocks = typeof props.customBlocks != 'undefined' ? props.customBlocks : {}; // Egyedi blokk komponensek: { blockCode: Component }
    this.customBlocksProps = typeof props.customBlocksProps != 'undefined' ? props.customBlocksProps : {}; // Egyedi blokk komponensek extra prop-jai: { blockCode: { prop1: value1, ... } }
    this.loader = typeof props.loader != 'undefined' ? props.loader : false; // Loading indikátor megjelenítése submit közben

    let formData = {};

    if (typeof props.form_data != 'undefined')
    {
      formData = {...props.form_data};
    } 

    if (this.hiddens && Object.keys(this.hiddens).length > 0)
    {
      formData = { ...formData, ...this.hiddens };
    }

    this.state = {
      formData: formData,
      formErrors: {},
      formErrorCodes: {}, // mezőnkénti utolsó hibakód (pl. same_data_value_exists), az error_message_overrides prop-hoz
      webshopParams: {},
      fullFormResponse: null, // Teljes form válasz a szerverről
      display_success: false,
      submit_disabled: false,
      loading: false, // Form submit folyamatban
      countdown: null, // pinkód újragenerálásnál használva
      editingBlock: null, // melyik block van szerkesztés alatt
      redirect: false, // átirányítás szükségessége
      redirectUrl: null, // átirányítás URL-je
    };
  }

  componentDidMount() {

    this.load_form_data();

  }

  clean_form_data(data) {
    const cleaned = {};
    if (data && typeof data === 'object') {
      Object.keys(data).forEach(key => {
        if (key !== '' && key !== 'undefined') {
          if (typeof data[key] === 'undefined' || data[key] === 'undefined') {
            cleaned[key] = '';
          } else {
            cleaned[key] = data[key];
          }
        }
      });
    }
    return cleaned;
  }

  prepare_form_data()
  {
      const { formData } = this.state;

      

      return formData;
  }

  /**
   * form adatok betöltése
   */
  load_form_data(reload_data = false) {

    let { formData } = this.state;

    if(this.form_source!=='server')
    {
      this.set_state_from_form_data(formData);
    }
    else
    {
      // Egyedi blokkok adatainak hozzáadása MIELŐTT POST-olunk
      const customBlocksData = this.getCustomBlocksData();
      formData = { ...formData, ...customBlocksData };
      
      const post_data = this.clean_form_data(formData);
      post_data.ajax_event = 'get_form';
      post_data.page_id = this.name;

      // Ha van nowUploaded a state-ben, azt is visszaküldjük
      if (this.state.nowUploaded) {
        post_data.now_uploaded = btoa(JSON.stringify(this.state.nowUploaded));

        // A most feltöltött fájlok nevét is visszaküldjük a megfelelő mezőkben
        Object.keys(this.state.nowUploaded).forEach(key => {
            if (this.state.nowUploaded[key]) {
                const fieldValue = Array.isArray(this.state.nowUploaded[key]) 
                  ? this.state.nowUploaded[key][0] 
                  : this.state.nowUploaded[key];
                  
                if (typeof post_data[key] === 'undefined' || post_data[key] === '') {
                   post_data[key] = fieldValue;
                }
            }
        });
      }

      if (reload_data) {
        post_data.reload = 1;
        post_data.ready_form = 1;
        post_data.is_form = 1;
      }

      if (this.others && Object.keys(this.others).length > 0)      {
        Object.keys(this.others).forEach(key => {
          post_data[key] = this.others[key];
        });
      }

      Utils.get_server_data(
        '',
        {ajax_event: 'get_form', page_id: this.name, APICACHE: 'false', ...this.query_params},
        post_data
      )
      .then((res) => {
          if(res.form){
            this.set_state_from_form_data(res.form);
          }
      });
    }

   
  }

  set_state_from_form_data(res, redirect = false, redirectUrl = null)
  {
    // Egyedi blokkok adatainak megtartása
    const customBlocksData = this.getCustomBlocksData();
    
    const new_state = {
      webshopParams: { ...res.items },
      formErrors: { ...res.messages },
      formErrorCodes: this.get_error_codes(res.messages),
      formData: { ...this.hiddens, ...this.state.formData, ...res.values, ...customBlocksData },
      nowUploaded: res.now_uploaded,
      nowDeleted: res.now_deleted,
      fullFormResponse: res, // Teljes res objektum tárolása
      display_success: this.state.display_success,
      redirect: redirect, // átirányítás beállítása
      redirectUrl: redirectUrl, // átirányítás URL-je
    }

    if (Object.keys(new_state.webshopParams))
    {
      Object.keys(new_state.webshopParams).forEach(key => {
        const fieldname = new_state.webshopParams[key].fieldname;

        if (typeof new_state.formErrors[fieldname] == 'undefined')
          new_state.formErrors[fieldname] = '';

        if (typeof new_state.formData[fieldname] == 'undefined')
        {
          new_state.formData[fieldname] = new_state.webshopParams[key]?.default;
        }

        // ha vannak alárendelt elemek
        if (typeof new_state.webshopParams[key].items !== 'undefined' && Object.keys(new_state.webshopParams[key].items).length)
        {
          Object.keys(new_state.webshopParams[key].items).forEach(key2 => {
            const fieldname = new_state.webshopParams[key].items[key2].fieldname;

            if (typeof new_state.formErrors[fieldname] == 'undefined')
              new_state.formErrors[fieldname] = '';

            if (typeof new_state.formData[fieldname] == 'undefined')
            {
              new_state.formData[fieldname] = new_state.webshopParams[key].items[key2]?.default;
            }
          });
        }
      });

      this.emptyFormErrors = {...new_state.formErrors};
      this.emptyFormData = {...new_state.formData};
    }

    this.setState(new_state, () => {
      this.syncHiddenInputsFromHTML();
      this.onLoaded && this.onLoaded();
    });
  }

  /**
   * HTML típusú elemekben lévő hidden inputok szinkronizálása a formData-val
   * Ha egy hidden input name-je megegyezik egy hiddens objektumban lévő kulccsal,
   * akkor felülírjuk a formData értékét a category_html-ben lévő értékkel
   * 
   * erre azért van szükség mert a hiddeneket nem külön elemként küldi a forms a netshop, hanem egy HTML blokkban helyezi el, így a hidden inputok értékét csak így tudjuk visszaszerezni és szinkronizálni a formData-val, hogy a form helyesen működjön
   */
  syncHiddenInputsFromHTML() {
    if (!this.state.webshopParams) return;
    
    const formData = { ...this.state.formData };
    let hasChanges = false;

    const processHTMLItem = (item) => {
      if (item.category === 'html' && item.category_html) {
        
        // Parse-oljuk a HTML stringet
        const parser = new DOMParser();
        const doc = parser.parseFromString(item.category_html, 'text/html');
        const hiddenInputs = doc.querySelectorAll('input[type="hidden"]');
        
        hiddenInputs.forEach(input => {
          const name = input.getAttribute('name');
          const value = input.getAttribute('value');
          
          // Ha a hidden input name-je benne van a hiddens objektumban
          if (name && this.hiddens.hasOwnProperty(name)) {
            formData[name] = value;
            hasChanges = true;
          }
        });
      }
    };

    Object.keys(this.state.webshopParams).forEach(key => {
      const item = this.state.webshopParams[key];
      
      // Felső szintű HTML elem
      processHTMLItem(item);
      
      // Alárendelt elemek
      if (item.items) {
        Object.keys(item.items).forEach(subKey => {
          processHTMLItem(item.items[subKey]);
        });
      }
    });

    if (hasChanges) {
      this.setState({ formData });
    }
  }

  /**
   * Egyedi blokkok adatainak összegyűjtése
   */
  getCustomBlocksData = () => {
    const customData = {};
    
    Object.keys(this.customBlockRefs).forEach(blockCode => {
      const ref = this.customBlockRefs[blockCode];
      if (ref && typeof ref.getFormData === 'function') {
        const blockData = ref.getFormData();
        Object.assign(customData, blockData);
      }
    });
    
    return customData;
  }

  /**
   * form adatok mentése
   */
  handle_submit(event) {

    event.preventDefault();

    let { formData } = this.state;
    
    // Egyedi blokkok adatainak hozzáadása
    const customBlocksData = this.getCustomBlocksData();
    formData = { ...formData, ...customBlocksData };

    if(this.on_save){

      this.on_save(formData);

    } else {
      // Meghívjuk az onBeforeSubmit callback-et, ha van, hogy a parent módosíthassa a formData-t
      // CSAK a fő submit esetén fut le, blokk mentésnél NEM
      if (this.onBeforeSubmit) {
        const modifiedFormData = this.onBeforeSubmit(formData);
        if (modifiedFormData) {
          formData = modifiedFormData;
        }
      }

      const after_response = (res) => 
      {
        // Meghatározzuk a redirect állapotokat először
        const shouldRedirect = res.redirect_url ? true : false;
        const redirectUrl = res.redirect_url ? res.redirect_url : null;

        if (res.form && res.form.items) {
           this.set_state_from_form_data(res.form, shouldRedirect, redirectUrl);
        }

        this.get_xhr_messages(res.form.messages, () => 
        {
          const { formErrors } = this.state;

          //ha van succes_id vagy redirektelni kell akkor sikeresnek tekintjük a mentést, egyébként maradunk a formon és kiírjuk a hibákat
          //checkout eseténben van hogy csak a bank_content érkezik vissza, de az is sikeres mentésnek számít
          if (parseInt(res.form?.success_id)>0 || res.redirect_url || res.bank_content) {
            this.onSuccess && this.onSuccess({formData, result: res});
          }
        });
      };

      const get_server_data = () => 
      {
        const post_data = this.clean_form_data(formData);
        post_data.ajax_event = 'get_form';
        post_data.page_id = this.name;
        post_data.ready_form = 1;
        post_data.ok = 1;

        if (this.others && Object.keys(this.others).length > 0){
          Object.keys(this.others).forEach(key => {
            post_data[key] = this.others[key];
          });
        }

        // Ha van nowUploaded a state-ben, azt is visszaküldjük
        if (this.state.nowUploaded) {
            post_data.now_uploaded = btoa(JSON.stringify(this.state.nowUploaded));

             // A most feltöltött fájlok nevét is visszaküldjük a megfelelő mezőkben
            Object.keys(this.state.nowUploaded).forEach(key => {
                if (this.state.nowUploaded[key]) {
                    const fieldValue = Array.isArray(this.state.nowUploaded[key]) 
                    ? this.state.nowUploaded[key][0] 
                    : this.state.nowUploaded[key];
                    
                    if (typeof post_data[key] === 'undefined' || post_data[key] === '') {
                        post_data[key] = fieldValue;
                    }
                }
            });
        }

        Utils.get_server_data(
            '',
            {ajax_event: 'get_form', page_id: this.name, APICACHE: 'false', ...this.query_params},
            post_data
          )
          .then((res) => {
            this.setState({submit_disabled: false, loading: false}, () => after_response(res));
        });

      };

      this.setState({submit_disabled: true, loading: true}, get_server_data);
    }    
  }

  /**
   * mezőnkénti utolsó hibakód kigyűjtése a szerver messages struktúrájából
   * (ha egy mezőn több hiba van, az utolsót írjuk ki)
   */
  get_error_codes(messages)
  {
    const codes = {};

    if (messages) {
      Object.keys(messages).forEach((key) => {
        const error_keys = Object.keys(messages[key] || {});

        if (error_keys.length > 0) {
          codes[key] = error_keys[error_keys.length - 1];
        }
      });
    }

    return codes;
  }

  /**
   * egyedi hibaüzenet keresése az error_message_overrides prop-ban
   * alakja: { fieldname: { error_code: string | ReactNode } }
   */
  get_error_message_override(fieldname, error_code)
  {
    const overrides = this.props.error_message_overrides || {};

    return (!!fieldname && !!error_code && !!overrides[fieldname]) ? overrides[fieldname][error_code] : undefined;
  }

  /**
   * mezőhöz tartozó hibaüzenet renderelése
   * ha az error_message_overrides-ban ReactNode van a mező aktuális hibakódjára, azt jelenítjük meg
   * (így lehet pl. react-router <Link> a hibaüzenetben), egyébként a szerver HTML szövegét
   */
  render_form_error(fieldname)
  {
    const { formErrors, formErrorCodes } = this.state;
    const error = formErrors[fieldname];
    const override = this.get_error_message_override(fieldname, formErrorCodes[fieldname]);

    if (React.isValidElement(override)) {
      return <div className="form_error">{override}</div>;
    }

    if (!error || typeof error !== 'string' || !error.length) {
      return '';
    }

    return <div className="form_error" dangerouslySetInnerHTML={{__html: error}}></div>;
  }

  get_xhr_messages(messages, cb = () => {})
  {
    const processed_messages = {};
    const processed_codes = this.get_error_codes(messages);

    if (messages) {
      Object.keys(messages).forEach((key) => {
        const error_code = processed_codes[key];

        if (error_code) {
          const error_data = messages[key][error_code];
          const override = this.get_error_message_override(key, error_code);

          // string override esetén a state-be is a felülírt szöveg kerül, a ReactNode változatot csak
          // render időben tesszük ki (render_form_error), hogy a formErrors string maradjon
          processed_messages[key] = (typeof override === 'string')
            ? override
            : (error_data.error_message_list || error_data.error_message); // error_message_list vagy error_message használata
        }
      });
    }

    this.setState({formErrors : Object.assign({ ...this.emptyFormErrors }, processed_messages), formErrorCodes: processed_codes}, () => {
      this.scrollToFirstError();
      if(typeof cb === 'function') cb();
    });
  }

  scrollToFirstError() {
    setTimeout(() => {
        const firstError = document.querySelector('.field.error, .block_error .form_error');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, 100);
  }

  /**
   * Block szerkesztő megnyitása
   */
  openBlockEditor = (blockKey) => {
    this.setState({ editingBlock: blockKey }, () => {
      if (this.slideInRef.current) {
        this.slideInRef.current.setVisible(true);
      }
    });
  }

  /**
   * Block szerkesztő bezárása
   */
  closeBlockEditor = () => {
    if (this.slideInRef.current) {
      this.slideInRef.current.setVisible(false);
    }
    // A SlideInContent onHidden callback-jében töröljük az editingBlock-ot
  }

  /**
   * Block szerkesztő mentése és bezárása
   */
  saveAndCloseBlockEditor = () => {
    let { formData, editingBlock, webshopParams } = this.state;
    
    // Egyedi blokkok adatainak hozzáadása
    const customBlocksData = this.getCustomBlocksData();
    formData = { ...formData, ...customBlocksData };
    
    // Blokk adatok elkészítése a callback számára
    const blockData = editingBlock && webshopParams[editingBlock] ? webshopParams[editingBlock] : null;
    
    // Ha van onBlockSave callback, meghívjuk az elküldés előtt
    if (this.onBlockSave && blockData) {
      this.onBlockSave(blockData, formData);
    }
    
    // Mentés a szerverre
    const post_data = this.clean_form_data(formData);
    post_data.ajax_event = 'get_form';
    post_data.page_id = this.name;
    post_data.reload = 1;
    post_data.ready_form = 1;
    post_data.is_form = 1;

    if (this.others && Object.keys(this.others).length > 0) {
      Object.keys(this.others).forEach(key => {
        post_data[key] = this.others[key];
      });
    }

    if (this.state.nowUploaded) {
      post_data.now_uploaded = btoa(JSON.stringify(this.state.nowUploaded));
      
      Object.keys(this.state.nowUploaded).forEach(key => {
        if (this.state.nowUploaded[key]) {
          const fieldValue = Array.isArray(this.state.nowUploaded[key]) 
            ? this.state.nowUploaded[key][0] 
            : this.state.nowUploaded[key];
            
          if (typeof post_data[key] === 'undefined' || post_data[key] === '') {
            post_data[key] = fieldValue;
          }
        }
      });
    }

    Utils.get_server_data(
      '', 
      {ajax_event: 'get_form', page_id: this.name, APICACHE: 'false'}, 
      post_data
    )
    .then((res) => {
      if (res.form) {
        this.set_state_from_form_data(res.form);
        
        // Hibák feldolgozása
        if (res.form.messages) {
          this.get_xhr_messages(res.form.messages, () => {
            // Csak akkor zárjuk be a panelt, ha nincs hiba
            const hasErrors = Object.keys(this.state.formErrors).some(
              key => this.state.formErrors[key] && this.state.formErrors[key].length > 0
            );
            
            if (!hasErrors) {
              this.closeBlockEditor();
            }
          });
        } else {
          this.closeBlockEditor();
        }
      } else {
        this.closeBlockEditor();
      }
    });
  }

  /**
   * SlideInContent bezáródása után
   */
  handleSlideOutComplete = () => {
    // Összegyűjtjük a custom block adatokat mielőtt bezáródik
    const customData = this.getCustomBlocksData();
    
    // Frissítjük a formData-t az új adatokkal
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
       ...customData
      },
      editingBlock: null
    }));
  }

  /**
   * Block summary nézet generálása
   */
  getBlockSummary = (blockItem) => {
    const { formData } = this.state;
    const summaryLines = [];

    if (blockItem.items && Object.keys(blockItem.items).length > 0) {
      Object.keys(blockItem.items).forEach(key => {
        const item = blockItem.items[key];
        const value = formData[item.fieldname];
        
        // Ha a mező ki van zárva a summary nézetből, akkor nem jelenítjük meg
        if (this.summaryExcludedFields.includes(item.fieldname)) {
          return;
        }
        
        // Mindig megjelenítjük, még ha nincs is érték
        let displayValue = value || '';
        
        if(item.category === undefined){
          return;
        }
        
        // Label feldolgozása: HTML tagek eltávolítása, csillag eltávolítása, kettőspont eltávolítása a végéről
        let label = item.label ? item.label.replace(/<[^>]*>/g, '').replace(' *', '').trim() : '';
        

        // Listbox esetén a megjelenített szöveget keressük
        if (value && item.category === 'listbox' && item.values && Object.keys(item.values).length > 0) {
          const selectedOption = (item.values[value]) ? item.values[value] : null;

          if (selectedOption) {
            displayValue = selectedOption;
          }
        }
        
        // Radio esetén a label-t keressük
        if (value && item.category === 'radio' && item.values && Object.keys(item.values).length > 0) {
          const selectedOption = (item.values[value]) ? item.values[value] : null;
          if (selectedOption) {
            displayValue = selectedOption;
          }
        }

        // Checkbox esetén a label-t keressük
        if (value && item.category === 'checkbox' && item.values && Object.keys(item.values).length > 0) {
          const selectedOption = (item.values[value]) ? item.values[value] : null;
          if (selectedOption) {
            displayValue = selectedOption;
          }
        }

        summaryLines.push({
          label: label,
          value: displayValue
        });
      });
    }

    return summaryLines;
  }

  handle_change(event, formDataKey, options = {}) {
    const formData = this.state.formData;

    formData[formDataKey] = typeof options.force_value !== 'undefined' ? options.force_value : event.target.value;
    
    if(formDataKey == 'area_code_phone_txt' || formDataKey == 'phone_section_1_phone_txt')
    {
      const str_len = formData[formDataKey].length;
      const is_max_len = (formDataKey=='area_code_phone_txt' && str_len==2) ? true : ((formDataKey=='phone_section_1_phone_txt' && str_len==3) ? true : false);

      if(is_max_len && formDataKey=='area_code_phone_txt')
      {
          if(this.inputRefs['phone_section_1_phone_txt']){
            this.inputRefs['phone_section_1_phone_txt'].focus();
          }
      }
      else if(is_max_len && formDataKey=='phone_section_1_phone_txt')
      {
          if(this.inputRefs['phone_section_2_phone_txt']){
            this.inputRefs['phone_section_2_phone_txt'].focus();
          }
      }
    }

    // ha input[type="number"] és van maxlength, akkor ne lehessen többet beírni
    if (!!options.item && options.item?.number && options.item?.text_maxlength > 0) {
      formData[formDataKey] = formData[formDataKey].substring(0, options.item.text_maxlength);
    }
    
    this.setState({formData}, () => {
      if (this.parent && typeof this.parent.on_form_change === 'function') {
        this.parent.on_form_change(formDataKey, formData[formDataKey]);
      }
    });
  }

  render_item_by_type(item, index = '') {
    const { formData, formErrors, webshopParams, fullFormResponse } = this.state;
    let { countdown } = this.state;

    let result = '';
  
    // ha a formData-ban a item.condition.fieldname mező értéke == item.condition.value, akkor az elem megjelenhet a formon, egyébként pedig nem
    // pl. my_netshop_v3.php form_processing_before()
    if (item?.condition?.fieldname && item?.condition?.value)
    {
      if (formData[item.condition.fieldname] + '' !== item.condition.value + '') {
        return ;
      }
    }

    // ha a formData-ban a item.conditional_required.fieldname mező értéke == item.condition.value, akkor az elem kötelező a formon, egyébként pedig nem
    // pl. my_netshop_v3.php form_processing_before()
    if (item?.conditional_required?.fieldname && typeof item?.conditional_required?.value !== 'undefined')
    {
      if (formData[item.conditional_required.fieldname] + '' == item.conditional_required.value + '') {
        item.required = 1;
      }
    }

    if (item?.conditional_value?.fieldname && item?.conditional_value?.fieldvalue && typeof item?.conditional_value?.value !== 'undefined')
    {
      if (formData[item.conditional_value.fieldname] + '' == item.conditional_value.fieldvalue + '' && typeof item.conditional_value_set === 'undefined') {
        formData[item.fieldname] = item.conditional_value.value;
        item.conditional_value_set = true;
      }
    }

    switch (item['category']) {
      case 'block':
        // Ellenőrizzük, hogy a block code-ja ki van-e véve a summary módból
        const blockCode = item.code || '';
        const isExcluded = this.summaryExcludedBlocks.includes(blockCode);
        const hasCustomBlock = !!this.customBlocks[blockCode];
        
        // Feldolgozzuk a blokkot, ha van items VAGY van custom komponens
        if (typeof item['items'] !== 'undefined' || hasCustomBlock)
        {
          // Ellenőrizzük, hogy van-e egyedi komponens ehhez a blokkhoz
          if (hasCustomBlock) {
            const CustomBlockComponent = this.customBlocks[blockCode];
            const blockKey = (item.fieldname && item.fieldname !== "") ? item.fieldname : index;
            const customProps = this.customBlocksProps[blockCode] || {};
            
            result = <CustomBlockComponent
              key={blockKey}
              ref={(ref) => { this.customBlockRefs[blockCode] = ref; }}
              form={this}
              blockData={item}
              formData={formData}
              formErrors={formErrors}
              fullFormResponse={fullFormResponse}
              summaryMode={this.summaryMode}
              onOpenEditor={() => this.openBlockEditor(blockKey)}
              appRef={this.parent?.appRef}
              {...customProps}
            />;
          }
          // Ha summary mode aktív ÉS a block nincs kivéve, summary nézetet renderelünk
          else if (this.summaryMode && !isExcluded) {
            const summaryData = this.getBlockSummary(item);
            const blockKey = (item.fieldname && item.fieldname !== "") ? item.fieldname : index;
            
            // Ellenőrizzük, hogy a blockhoz tartozó mezőknek van-e hibája
            let blockHasError = false;
            if (item.items && Object.keys(item.items).length > 0) {
              Object.keys(item.items).forEach(key => {
                const fieldItem = item.items[key];
                if (fieldItem.fieldname && formErrors[fieldItem.fieldname] && formErrors[fieldItem.fieldname].length > 0) {
                  blockHasError = true;
                }
              });
            }
            
            result = <div key={blockKey} className={`form_block_summary ${item.class} ${blockHasError ? 'has_error' : ''}`}>
              <div className="block_header">
                <h3 className="block_title">{item.label ? item.label.replace(/<[^>]*>/g, '') : ''}</h3>
                <ReactSVG 
                  className="edit_icon" 
                  src="/assets/images/edit.svg" 
                  onClick={() => this.openBlockEditor(blockKey)}
                />
              </div>
              {blockHasError && (
                <div className="block_summary_error">
                  {Object.keys(item.items || {}).map(key => {
                    const fieldItem = item.items[key];
                    const fieldError = formErrors[fieldItem.fieldname];
                    if (fieldError && fieldError.length > 0) {
                      return <div key={fieldItem.fieldname} className="form_error" dangerouslySetInnerHTML={{__html: fieldError}}></div>;
                    }
                    return null;
                  })}
                </div>
              )}
              <div className="block_summary_content">
                {summaryData.map((line, idx) => (
                  <div key={idx} className={`summary_line ${!line.value ? 'empty' : ''}`}>
                    <span className="summary_label">{line.label}</span>
                    <span className="summary_value"> {line.value}</span>
                  </div>
                ))}
              </div>
            </div>;
          } else {
            // Normál nézet (ha nincs summary mode, vagy a block ki van véve)
            result = <div key={(item.fieldname && item.fieldname !== "") ? item.fieldname : index} className={'form_block '+item.class}>
              {Object.keys(item['items'])
                .map(key => this.render_item_by_type(item['items'][key], key))} 
            </div>;
          }
        }
        break;
      case '':
          result = <div key={(item.fieldname && item.fieldname !== "") ? item.fieldname : index} className={`row ${item.class}`}><p dangerouslySetInnerHTML={{__html:item.label}}></p></div>;
        break
      case 'datamask':
        if (typeof item['items'] !== 'undefined')
        {
          result = <div key={(item.fieldname && item.fieldname !== "") ? item.fieldname : index} className={`row block ${item.fieldname}`}> 
            <label className="field_label" dangerouslySetInnerHTML={{__html: item.label + (item.required ? ' *' : '')}}></label>
            <div className="block_content">
              {Object.keys(item['items'])
                .map(key => this.render_item_by_type(item['items'][key], key))} 
            </div>
            <div className="block_error">
              {this.render_form_error(item.fieldname)}
            </div>
          </div>;
        }
        break;
      case 'html':
        result = <Html ref={(input)=>{this.inputRefs[item.fieldname] = input;}} key={item.fieldname} parent={this} ws_data={item}></Html>
        break;
      case 'upload_file':
        result = <File ref={(input)=>{this.inputRefs[item.fieldname] = input;}} key={item.fieldname} parent={this} ws_data={item}></File>
        break;
      case 'text':
        
        // a felhasználó e-mail címe megvan localstorage-ban, ez alapján kitöltjük az email cím mezőket
        if (item?.fieldname == 'email_txt')
        {
          let login_email = Utils.localSorageGetWithExpiry('login_email_' + i18n.resolvedLanguage);

          if (!!login_email)
          {
            formData[item.fieldname] = login_email;
          }
        }

        // pinkód mező esetén meg kell jeleníteni a pinkód újragenerálása gombot és a visszaszámlálót
        if (item?.fieldname == 'email_pswpin_code')
        {
          const on_refresh_click = () => {
            if (this.state.countdown <= 0)
            {
              this.setState({countdown: 31}, () => {
                let timer = setInterval(() => {
                    if (--this.state.countdown < 1) 
                    {
                      
                      formData.registration = 1;

                      Utils.get_server_data(
                        '',
                        {
                          ajax_event:'resend_email_pin_code',
                          APICACHE:'false'
                        }, 
                        {
                          ajax_event: 'resend_email_pin_code',
                          formData: JSON.stringify(formData),
                        }
                      );

                      clearInterval(timer);
                    }
    
                    this.setState({countdown: this.state.countdown, webshopParams});
                  }, 1000);
              });
            }
          };

          item.html_after_input = <div className="html_after_input"><ReactSVG onClick={on_refresh_click} className="refresh_icon" src={`assets/images/refresh.svg`}></ReactSVG>{countdown ? <span className="countdown" dangerouslySetInnerHTML={{__html: i18n.t('pinCodeResendText').replace('{x}', countdown)}}></span> : ''}</div>;
        }

        result = <Text ref={(input)=>{this.inputRefs[item.fieldname] = input;}} key={item.fieldname+'_text'} parent={this} ws_data={item}></Text>
        break;
      case 'radio':
        result = <Radio ref={(input)=>{this.inputRefs[item.fieldname] = input;}} key={item.fieldname+'_radio'} parent={this} ws_data={item}></Radio>
        break;
      case 'checkbox':
        result = <Checkbox ref={(input)=>{this.inputRefs[item.fieldname] = input;}} key={item.fieldname+'_checkbox'} parent={this} ws_data={item}></Checkbox>
        break;
      case 'textarea':
        result = <Textarea ref={(input)=>{this.inputRefs[item.fieldname] = input;}} key={item.fieldname+'_textarea'} parent={this} ws_data={item}></Textarea>
        break;
      case 'listbox':
        result = <Select ref={(input)=>{this.inputRefs[item.fieldname] = input;}} key={item.fieldname+'_listbox'} parent={this} ws_data={item}></Select>
        break;
    }

    return result;
  }

  render() {
    const { formErrors, webshopParams, display_success, submit_disabled, loading, editingBlock, formData, fullFormResponse, redirect, redirectUrl } = this.state;

    // Ha sikeres mentés után redirect_url érkezett, átirányítjuk a felhasználót
    if (redirect === true && redirectUrl) {
      const isExternalUrl = redirectUrl.startsWith('http://') || redirectUrl.startsWith('https://');
      
      if (isExternalUrl) {
        // External URL esetén window.location használata
        window.location.href = redirectUrl;
        return null;
      } else {
        // Belső route esetén Navigate használata
        return <Navigate to={'/content/'+redirectUrl} replace />
      }
    }

    if (!Object.keys(webshopParams).length) return '';

    // Szerkesztendő block adatai
    const editingBlockData = editingBlock && webshopParams[editingBlock] ? webshopParams[editingBlock] : null;
    const editingBlockCode = editingBlockData ? (editingBlockData.code || '') : '';
    const EditingCustomBlockComponent = editingBlockCode && this.customBlocks[editingBlockCode] ? this.customBlocks[editingBlockCode] : null;

    return <>
      {this.loader && loading && (
        <div className="form-loader-overlay">
          <div className="form-loader-spinner"></div>
        </div>
      )}
      <form onSubmit={(e) => this.handle_submit(e)}>

        {Object.keys(webshopParams).map(key => {
          return typeof webshopParams[key]['category'] !== 'undefined' 
            ? this.render_item_by_type(webshopParams[key],key) 
            : '';
        })}
       
        {this.hiddens && Object.keys(this.hiddens).map(key => {
          return <input key={key} type="hidden" name={key} value={this.hiddens[key]} />
        })}

        <div className={`row`}>
          <div className={`field`}>
            {(display_success) 
            ? <div className="form_success submit_success" dangerouslySetInnerHTML={{__html: formErrors.summary}}></div> : '' }

              <input disabled={submit_disabled} type="submit" value={this.submit_text} />
          </div>
        </div>

      </form>

      {/* Szerkesztő panel SlideInContent-tel */}
      {this.summaryMode && editingBlock && (
        <div className="form_block_editor_overlay" onClick={this.closeBlockEditor}></div>
      )}
      {this.summaryMode && (
        <SlideInContent 
          ref={this.slideInRef}
          className="form_block_editor"
          onHidden={this.handleSlideOutComplete}
        >
          {editingBlockData && (
            <div className="editor_content">
              <div className="editor_header">
                <h2>{editingBlockData.label ? editingBlockData.label.replace(/<[^>]*>/g, '') : ''}</h2>
                <ReactSVG 
                  className="close_icon" 
                  src="/assets/images/close.svg" 
                  onClick={this.closeBlockEditor}
                />
              </div>
              <div className="editor_form">
                {EditingCustomBlockComponent ? (
                  <EditingCustomBlockComponent
                    ref={(ref) => { this.customBlockRefs[editingBlockCode] = ref; }}
                    form={this}
                    blockData={editingBlockData}
                    formData={formData}
                    formErrors={formErrors}
                    webshopParams={webshopParams}
                    fullFormResponse={fullFormResponse}
                    summaryMode={false}
                    onOpenEditor={() => {}}
                    appRef={this.parent?.appRef}
                    {...(this.customBlocksProps[editingBlockCode] || {})}
                  />
                ) : (
                  Object.keys(editingBlockData.items || {}).map(key => 
                    this.render_item_by_type(editingBlockData.items[key], key)
                  )
                )}
              </div>
              <div className="editor_actions">
                <button 
                  type="button" 
                  className="save_button" 
                  onClick={this.saveAndCloseBlockEditor}
                >
                  {i18n.t('saveFormPart') || 'Mentés'}
                </button>
              </div>
            </div>
          )}
        </SlideInContent>
      )}
    </>;    
  }
};

export default Form;